// src/store/selectors/AuthSelectors.js

export const isAuthenticated = (state) => {
    return !!state.auth.auth.token;
};

export const getUser = (state) => {
    return state.auth.auth.user || {};
};

export const getUserName = (state) => {
    return state.auth.auth.user?.name || '';
};

export const getUserEmail = (state) => {
    return state.auth.auth.user?.email || '';
};

export const getUserRole = (state) => {
    return state.auth.auth.user?.role || '';
};

export const getUserId = (state) => {
    return state.auth.auth.user?.id || null;
};

export const getUserMobile = (state) => {
    return state.auth.auth.user?.mobile || '';
};
